export const validateLink = (rule: any, value: any, callback: any) => {
  // Regular expression pattern for a URL
  const urlPattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;

  if (!value || urlPattern.test(value)) {
    // Valid URL or empty field, no validation error
    callback();
  } else {
    callback("Ingrese un enlace válido (ejemplo: http://www.ejemplo.com)");
  }
};
